import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ActionCommand, SelectListitem } from "app/common/models/models";
import { LocationReferenceType, QRCodeReference } from "app/models/object-space.model";
import { LocationReferencePreviewComponent } from "./location-reference-preview.component";


@Component({
	selector: 'beacon-preview',
	templateUrl: './beacon-reference-preview.component.html',
	styles: [`
		.my-content-card {
			display: flex;
			align-items: flex-start;
			flex-direction: row;
			justify-content: flex-start;
			align-content: flex-start;
		}
		.heigth-20 {
			height: 20% !important;
		}
		.heigth-80 {
			height: 80% !important;
		}
  `]
})



export class BeaconCodePreview extends LocationReferencePreviewComponent {
	possibleUUIDs: SelectListitem[] = [];
	constructor(_fb: FormBuilder) {
		super(_fb)
	}
	
	protected initForm = () => {
		this.possibleUUIDs.push(new SelectListitem("ABCDEFGHILMNO", "uuid di default"));
		this.possibleUUIDs.push(new SelectListitem("MAMAMAMAMAMAMA", "Area metropolinana di Benevento"));
		this.form = this._fb.group({
			id: [null],
			type: [LocationReferenceType.beacon],

			uuid: [null, [Validators.required]],
			major: [null, [Validators.required]],
			minor: [null, [Validators.required]]
		});

	}
}